<template>
  <div>
    <Head :title="title" />
    <div class="w-full overflow-hidden bg-white rounded-md shadow">
      <form @submit.prevent="store">
          <div class="flex flex-wrap p-8 -mb-8 -mr-6">
          <text-input v-model="form.name" :error="form.errors.name" class="w-full pb-8 pr-6 lg:w-1/2" :label="__('Name')" />
              <text-input v-model="form.slug" :error="form.errors.slug" class="w-full pb-8 pr-6 lg:w-1/2" :label="__('Slug')" />
        </div>
          <div class="flex flex-wrap py-8 -mb-8 -mr-6 overflow-x-auto">
              <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                  <div class="overflow-hidden">
                      <table class="min-w-full">
                          <thead class="border-b">
                          <tr>
                              <th scope="col" class="px-6 py-4 text-sm font-bold text-left text-gray-900">
                                  Ressources
                              </th>
                              <th scope="col" class="px-6 py-4 text-sm font-bold text-left text-gray-900">
                                  Voir
                              </th>
                              <th scope="col" class="px-6 py-4 text-sm font-bold text-left text-gray-900">
                                  Mettre à jour
                              </th>
                              <th scope="col" class="px-6 py-4 text-sm font-bold text-left text-gray-900">
                                  Créer
                              </th>
                              <th scope="col" class="px-6 py-4 text-sm font-bold text-left text-gray-900">
                                  Supprimer
                              </th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr class="border-b" v-for="(value, name, index) in form.access" :key="index">
                              <td class="px-6 py-4 text-sm text-gray-900 capitalize whitespace-nowrap"> {{ name }} </td>
                              <td class="px-6 py-4 text-sm font-light text-gray-900 whitespace-nowrap">
                                  <label class="flex items-center cursor-pointer toggle_swtich">
                                      <div class="relative">
                                          <input type="checkbox" class="sr-only" v-model="value.read" />
                                          <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                          <div class="absolute w-6 h-6 transition bg-white rounded-full shadow dot -left-1 -top-1"></div>
                                      </div>
                                  </label>
                              </td>
                              <td class="px-6 py-4 text-sm font-light text-gray-900 whitespace-nowrap">
                                  <label class="flex items-center cursor-pointer toggle_swtich">
                                      <div class="relative">
                                          <input type="checkbox" class="sr-only" v-model="value.update" />
                                          <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                          <div class="absolute w-6 h-6 transition bg-white rounded-full shadow dot -left-1 -top-1"></div>
                                      </div>
                                  </label>
                              </td>
                              <td class="px-6 py-4 text-sm font-light text-gray-900 whitespace-nowrap">
                                  <label class="flex items-center cursor-pointer toggle_swtich">
                                      <div class="relative">
                                          <input type="checkbox" class="sr-only" v-model="value.create" />
                                          <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                          <div class="absolute w-6 h-6 transition bg-white rounded-full shadow dot -left-1 -top-1"></div>
                                      </div>
                                  </label>
                              </td>
                              <td class="px-6 py-4 text-sm font-light text-gray-900 whitespace-nowrap">
                                  <label class="flex items-center cursor-pointer toggle_swtich">
                                      <div class="relative">
                                          <input type="checkbox" class="sr-only" v-model="value.delete" />
                                          <div class="w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
                                          <div class="absolute w-6 h-6 transition bg-white rounded-full shadow dot -left-1 -top-1"></div>
                                      </div>
                                  </label>
                              </td>
                          </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
        <div class="flex items-center justify-end px-8 py-4 border-t border-gray-100 bg-gray-50">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Ajouter un role') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Link, Head } from '@inertiajs/vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Ajouter un nouveau role' },
  components: {
    LoadingButton,
    TextInput,
    Link,
    Head,
  },
  layout: Layout,
  props: {
      title: String
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: null,
          slug: null,
          access: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('roles.store'))
    },
  },
    created() {
        // "faq": { "read": false, "create": false, "delete": false, "update": false },
        //     "blog": { "read": false, "create": false, "delete": false, "update": false },
        //     "chat": { "read": false, "create": false, "delete": false, "update": false },
        //     "smtp": { "read": false, "create": false, "delete": false, "update": false },
        
        //"global": { "read": false, "create": false, "delete": false, "update": false },
            // "pusher": { "read": false, "create": false, "delete": false, "update": false },
            // "customer": { "read": false, "create": false, "delete": false, "update": false },
            // "language": { "read": false, "create": false, "delete": false, "update": false },
            // "organization": { "read": false, "create": false, "delete": false, "update": false },
            // "email_template": { "read": false, "create": false, "delete": false, "update": false },
            // "knowledge_base": { "read": false, "create": false, "delete": false, "update": false },
            // "front_page": { "read": false, "create": false, "delete": false, "update": false }
        this.form.access = {
           
            "user": { "read": false, "create": false, "delete": false, "update": false },
            
            "status": { "read": false, "create": false, "delete": false, "update": false },
            "ticket": { "read": false, "create": false, "delete": false, "update": false },
            "contact": { "read": false, "create": false, "delete": false, "update": false },
            "category": { "read": false, "create": false, "delete": false, "update": false },
            "type": { "read": false, "create": false, "delete": false, "update": false },
            "priority": { "read": false, "create": false, "delete": false, "update": false },
            "department": { "read": false, "create": false, "delete": false, "update": false },
            "phone_list": { "read": false, "create": false, "delete": false, "update": false },
            "phone_list_log": { "read": false, "create": false, "delete": false, "update": false },
            
        };
    }
}
</script>
